import { render, staticRenderFns } from "./PlanRequest.vue?vue&type=template&id=37311dad"
import script from "./PlanRequest.vue?vue&type=script&lang=js"
export * from "./PlanRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports